import { SprayOrSprayZoneChartConfigDto, SprayOrSprayZoneChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';

import SprayChart from 'components/Charts/SprayChart/SprayChart';
import SprayZoneChart from 'components/Charts/SprayZoneChart/SprayZoneChart';

const SprayOrSprayZoneChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<SprayOrSprayZoneChartDataDto, SprayOrSprayZoneChartConfigDto>) => {
  return chartConfig.viewChartAs === 'SprayChart' ? (
    <SprayChart sprays={chartData?.sprays ?? []} isLoading={isLoading} />
  ) : (
    <SprayZoneChart sprayZones={chartData?.sprayZones ?? []} isLoading={isLoading} />
  );
};

export default SprayOrSprayZoneChart;
